
import React from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface PaymentFormActionsProps {
  onCancel: () => void;
  isPending: boolean;
  paymentAmount: string;
  disabled?: boolean;
}

const PaymentFormActions: React.FC<PaymentFormActionsProps> = ({
  onCancel,
  isPending,
  paymentAmount,
  disabled = false,
}) => {
  const { t } = useTranslation();

  const isFormValid = paymentAmount && parseFloat(paymentAmount) > 0;

  return (
    <div className="flex gap-3 pt-4">
      <Button
        type="button"
        variant="outline"
        onClick={onCancel}
        className="flex-1"
        disabled={isPending}
      >
        {t('clients.cancel')}
      </Button>
      <Button
        type="submit"
        className="flex-1"
        disabled={isPending || !isFormValid || disabled}
      >
        {isPending ? 'Επεξεργασία...' : 'Καταγραφή Πληρωμής'}
      </Button>
    </div>
  );
};

export default PaymentFormActions;
